import bech32 from '../utils/bech32_ada';

// https://github.com/Chia-Network/chia-blockchain/wiki/Chia-Burn-Address
export default {
    isValidAddress(address, currency, opts = {}) {
        const decoded = bech32.decode(address, bech32.encodings.BECH32M);
        if (!decoded || !decoded.hrp) {
            return false;
        }

        return decoded.hrp === 'xch';
    },
};
